module.exports = __webpack_public_path__ + "img/清华大学logo.f36c4596.png";